import { render, staticRenderFns } from "./vcToolbarCrud.vue?vue&type=template&id=b689e4b0&"
import script from "./vcToolbarCrud.vue?vue&type=script&lang=js&"
export * from "./vcToolbarCrud.vue?vue&type=script&lang=js&"
import style0 from "./vcToolbarCrud.vue?vue&type=style&index=0&id=b689e4b0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports